var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.$auth.ready())?[_c('router-view')]:_vm._e(),(!_vm.$auth.ready())?void 0:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }